import { render } from "./mxjerseys.vue?vue&type=template&id=36585677&scoped=true"
import script from "./mxjerseys.vue?vue&type=script&lang=js"
export * from "./mxjerseys.vue?vue&type=script&lang=js"

import "./mxjerseys.vue?vue&type=style&index=0&id=36585677&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36585677"]])

export default __exports__